const forumContent = [
    {
      headline: "How are my plant died after giving them fertilizer?😭",
      user: "@joseph477",
      image: "https://picsum.photos/id/237/50",
      answer: "Too much fertilizer can potentially cause a chemical burn on the roots of your plant. In severe cases, it can also cause the whole plant to wilt and die."
    },
    {
      headline: "How to bring my sunflower back to life?",
      user: "@unknown123",
      image: "https://picsum.photos/id/1/50",
      answer: "You should first identify what’s the specific reason causing your sunflower dead. But normally you can try to transplant your sunflower to sunniest area in your garden and also ...."
    },
    {
      headline: "What are the white spots on my plants?",
      user: "@plant_lover",
      image: "https://picsum.photos/id/500/50",
      answer: "Powdery mildew. You can also try out the AI plant disease detection from LetItGrow."
    }
  ];

  export default forumContent;